
<div class="modal right fade" id="newOrder" tabindex="-1" role="dialog" aria-labelledby="newOrderLabel">
        <div class="modal-dialog" style="width:70%" role="document">
            <div class="modal-content new-work-screen">
                <div class="modal-header bg-light">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title fs18" id="newTaskLabel" ng-if="newOrderData.id">KargoGüncelle</h4>
                    <h4 class="modal-title fs18" id="newTaskLabel" ng-if="!newOrderData.id">Yeni Kargo</h4>
                </div>
            
                <form name="newWork" ng-submit="newOrder(newWork.$valid)" novalidate>
                    <div class="modal-body">
                        <div class="row">
                            <div class="loading" ng-if="!orderData">
                                <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                            </div>
                            
                            <div class="col-md-12">
    
                                <div class="col-md-6 pn mn">
    
                                    <div class="first-address">
                                        <h4>Gönderici Müşteri Detayları</h4>
                                        <div class="col-md-6 pln">
                                            
                                            <div class="form-group" ng-class="{ 'has-error': newWork.customer_name.$invalid && newWork.customer_name.$touched }">
                                                <div angucomplete-alt
                                                    name="customer_name"
                                                    ng-model="newOrderData.address.customer_name"
                                                    placeholder="Müşteri Adı"
                                                    pause="100"
                                                    selected-object="addressSelected"
                                                    remote-url="api/find-customer?s="
                                                    remote-url-data-field="customers"
                                                    search-fields="customer_name,phone_number,address"
                                                    title-field="customer_name"
                                                    description-field="address"
                                                    minlength="1"
                                                    input-class="form-control input-md"
                                                    match-class="highlight"
                                                    >
                                                </div>
                                            </div>
                                        </div>
    
                                        <div class="col-md-6 prn">
    
                                            <div class="form-group" 
                                                ng-class="{ 'has-error': newWork.phone_number.$invalid }">
                                                <div class="input-group">
                                                    <input 
                                                        type="text" 
                                                        class="form-control md" 
                                                        ui-mask="(999) 999-9999"  
                                                        ui-mask-placeholder 
                                                        ui-mask-placeholder-char=" " 
                                                        name="phone_number"
                                                        ng-model="newOrderData.address.phone_number">
                                                    <!-- <a href="#" 
                                                        ng-click="addReceiver()"
                                                        class="input-group-addon danger hint--medium hint--top-left " 
                                                        aria-label="Müşteri dışında iş bilgilerini göndermek istediğiniz kişileri ekleyebilirsiniz.">
                                                        <i class="fa fa-plus"></i> 
                                                    </a> -->
                                                </div>
    
                                                <!-- <div class="input-group mt5" 
                                                    ng-repeat="item in newOrderData.receivers">
                                                    <input 
                                                    type="text" 
                                                    class="form-control md" 
                                                    ui-mask="(999) 999-9999"  
                                                    ui-mask-placeholder ui-mask-placeholder-char=" " 
                                                    ng-model="item.phone_number">
    
                                                    <span class="input-group-addon danger">
                                                        <a href="#" ng-click="removeReceiver($index)"><i class="fa fa-trash"></i></a>
                                                    </span>
                                                </div> -->
    
                                            </div>
    
                                        </div>
    
                                        <div class="form-group" 
                                            ng-class="{ 'has-error': newWork.address.$invalid }">
                                            <div class="input-group">
                                                <input 
                                                google-place ng-model="newOrderData.address.address" 
                                                ng-change="addressSelected(newOrderData.address.address,'search')" 
                                                id="googlePlaceInput" 
                                                class="form-control input-md" 
                                                placeholder="Adres" 
                                                name="address"
                                                required/>
                                                <span class="input-group-addon danger">
                                                    <a href="#" class="hint--medium hint--top-left " aria-label="Adresin caddesini yazarak çıkan önermelerden size uygun olanı seçiniz. İsterseniz map üzerindeki ikonu sürükleyerekte gideceğiniz adresi seçebilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                                </span>
                                            </div>
                                        </div>
    
                                        <div class="col-md-4 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.address.city" placeholder="İl" class="form-control input-md br0">
                                            </div>
                                        </div>
    
                                        <div class="col-md-4 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.address.district" placeholder="İlçe" class="form-control input-md br0">
                                            </div>
                                        </div>
    
                                        <div class="col-md-2 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.address.building_number" placeholder="Bina No" class="form-control input-md br0">
                                            </div>
                                        </div>
    
                                        <div class="col-md-2 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.address.apartment_number" placeholder="Daire No" class="form-control input-md br0">
                                            </div>
                                        </div>
    
                                        <div class="form-group">
                                            <div class="input-group">
                                                <input type="text" ng-model="newOrderData.address.directions" placeholder="Adres Tarifi" class="form-control input-md">
                                                <span class="input-group-addon danger">
                                                    <a href="#" class="hint--medium hint--top-left " aria-label="Çalışanın adresi daha rahat bulması için adres tarifi girebilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
    
                                    <p class="help-block">* Harita üzerindeki ikonu sürükleyerek'te adresi seçebilirsiniz.</p>
                                    <div id="map-order"></div>
    
    
                                    <div class="form-group mt10">
                                        <label>Başlama Tarihi</label> <br>
                                        <input id="datetimepicker" type="text" class="form-control input-md" value="" ng-model="newOrderData.scheduled_time">
                                    </div>
    
                                    <div class="form-group">
                                        <ui-select 
                                            ng-model="newOrderData.worker_id" 
                                            title="Personel Kişi" 
                                            duplicates-allowed="false"
                                            name="personnel"
                                            >
                                            <ui-select-match placeholder="Personel Seçiniz...">
                                                <span ng-bind="$select.selected.full_name"></span>
                                            </ui-select-match>
                                            <ui-select-choices repeat="item.id as item in (orderData.workers | filter: $select.search ) track by $index">
                                                <div class="row mr10 ml10">
                                                    <span ng-bind="item.user.full_name"></span>
                                                    <span class="pull-right label label-success" ng-if="item.status == 1">Açık</span>
                                                    <span class="pull-right label label-default" ng-if="item.status == 0">Kapalı</span>
                                                </div>
                                            </ui-select-choices>
                                        </ui-select>
                                    </div>
    
    
                                    <hr>
        
                                    <div class="form-group mt10">
                                        <div class="row pn mn mb10" ng-repeat="item in newOrderData.notifications">
                                            <div class="col-md-4 pr5 pl5">
                                                <select ng-model="item.type" class="form-control">
                                                    <option value="push">Mobil Bildirim</option>
                                                    <option value="sms">Sms</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3 pr5 pl5">
                                                <input type="text" ng-model="item.time" placeholder="Zaman" class="form-control input-md">
                                            </div>
                                            <div class="col-md-4 pr5 pl5">
                                                <select ng-model="item.period" class="form-control">
                                                    <option value="minute">dakika önce</option>
                                                    <option value="hour">saat önce</option>
                                                    <option value="day">gün önce</option>
                                                </select>
                                            </div>
                                            <div class="col-md-1 pr5 pl5">
                                                <a href="#" ng-click="removeOrderNotification($index)"><i class="fa fa-times"></i></a>
                                            </div>
                                        </div>
                                        <a href="#" ng-click="addOrderNotification()">
                                            <strong> <i class="fa fa-plus"></i> Bildirim Ekle</strong>
                                        </a>
                                    </div>
        
                                    <div class="clearfix"></div>
        
                                    <!-- <a href="#" class="list-group-item" data-toggle="collapse" data-target="#image">
                                        <strong> <i class="fa fa-image"></i> Resim Ekle </strong>
                                    </a>
        
                                    <div class="collapse" id="image">
                                        <div class="form-group"  ng-class="{ 'has-error': newWork.file.$invalid && newWork.file.$touched}">
                                            <label class="control-label mt10">
                                                <span class="btn btn-primary btn-xs btn-file ph5">
                                                    <span class="fileupload-new"> <i class="fa fa-cloud"></i> Resim Yükle</span>
                                                    <input type="file" name="file" nv-file-select uploader="logo" multiple>
                                                </span>
                                            </label>
                                            <div class="fileupload fileupload-new" data-provides="fileupload">
                                                <div class="fileupload-preview thumbnail mb20" ng-if="newOrderData.images.length > 0">
                                                    <div class="col-md-4" ng-repeat="image in newOrderData.images">
                                                        <img 
                                                            ng-if="image.url"
                                                            class="img-responsive center"
                                                            ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ image.url }}"
                                                        />
                                                        <img 
                                                            ng-if="!image.url"
                                                            class="img-responsive center"
                                                            ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ image }}"
                                                        />
                                                        <a href="#" ng-click="deleteImgFromNewOrder(image)" class="btn btn-danger btn-sm m5"><i class="fa fa-trash"></i></a>
                                                    </div>
                                                </div>
                                                <div class="progress" ng-if="progress">
                                                    <div class="progress-bar progress-bar-success progress-bar-striped active" 
                                                        role="progressbar" 
                                                        ng-style="{ 'width': logo.progress + '%' }">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
        
                                    <!-- <a href="#" class="list-group-item" data-toggle="collapse" data-target="#type" ng-if="orderData.workTypes.length > 0">
                                        <strong> <i class="fa fa-plus"></i> Kargo Türü Seç</strong>
                                    </a>
        
                                    <div class="collapse" id="type" ng-if="orderData.workTypes.length > 0">
                                        <div class="form-group p5 mt10">
                                            <div class="radio-custom radio-primary pln radio-inline mb5 mln" ng-repeat="item in orderData.workTypes">
                                                <input type="radio" id="{{ item.id }}" value="{{ item.id }}" name="type" ng-model="newOrderData.work_type">
                                                <label for="{{ item.id }}">{{ item.name }}</label>
                                            </div>
                                        </div>
                                    </div> -->
        
        
                                    <!-- <a href="#" class="list-group-item" ng-if="!newOrderData.repeat.period" ng-click="toggleRepeat(true)"><strong> <i class="fa fa-repeat"></i> Tekrar Ekle</strong></a>
                                    <a href="#" class="list-group-item" ng-if="newOrderData.repeat.period" ng-click="toggleRepeat(false)"><strong> <i class="fa fa-repeat"></i> Tekrarı Kapat</strong></a>
        
                                    <div class="form-group mt10" ng-if="newOrderData.repeat.period">
                                        <div class="row pn mn p10" >
                                            <div class="col-md-4 pr5 pl5">
                                                <label for="">Tür</label>
                                                <select ng-model="newOrderData.repeat.period" class="form-control">
                                                    <option value="day">Her Gün</option>
                                                    <option value="selected_days">Belirli Günler</option>
                                                    <option value="week">Her Hafta</option>
                                                    <option value="month">Her Ay</option>
                                                </select>
                                            </div>
                                            <div 
                                            class="col-md-8 pr5 pl5">
                                                <label for="">
                                                    Bitiş Tarihi
                                                    <a href="#" class="hint--medium hint--top-left" aria-label="Bitiş tarihi seçerseniz, seçtiğiniz tarihte iş tekrarı sonlanacaktır."><i class="fa fa-question-circle"></i> </a> </label>
                                                </label>
                                                <input type="date" ng-model="newOrderData.repeat.end" class="form-control">
                                            </div>
                                        </div>
                                        <div class="row ml20 mt10" 
                                            ng-if="newOrderData.repeat.period == 'selected_days'">
                                            <label class="checkbox-inline mr10" ng-repeat="item in newOrderData.repeat.days">
                                                <input type="checkbox" 
                                                ng-checked="item.checked"
                                                ng-click="toggleDays(item)" id="{{ item.value }}">{{ item.name }}
                                            </label>
                                        </div>
                                    </div>
        
                                    <a href="#" class="list-group-item" data-toggle="collapse" data-target="#productnumber">
                                        <strong> 
                                            <i class="fa fa-tag"></i> Ürün Numarası
                                            <span class="hint--medium hint--top" aria-label="Ürün takibi yapmak isterseniz, bu alana virgül ile ayırarak ürün numaralarınızı girebilirsiniz."><i class="fa fa-question-circle"></i> </span>                                    
                                        </strong>
                                    </a>
        
                                    <div class="collapse" id="productnumber">
                                        <div class="form-group mt10">
                                            <input type="text" ng-model="newOrderData.special_value" placeholder="Ürün Numarası" class="form-control input-md">
                                        </div>
                                    </div> -->
    
    
        
                                    <a href="#" class="list-group-item" data-toggle="collapse" data-target="#order_special" ng-if="orderData.orderFields.length > 0">
                                        <strong> <i class="fa fa-info-circle"></i> KargoÖzel Alanları </strong>
                                    </a>
        
                                    <div class="collapse" id="order_special">
                                        <div class="form-group mt10">
                                            <div class="form-group" ng-repeat="item in orderData.orderFields">
                                                <label for="">{{ item.name }}</label>
                                                <div ng-if="item.type == 'text'">
                                                    <input type="text"
                                                        ng-init="item.field_value ? newOrderData.fields[item.id] = item.field_value.value : '' "
                                                        ng-model="newOrderData.order_fields[item.id]" 
                                                        class="form-control" 
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'number'">
                                                    <input type="text"
                                                        ng-init="item.field_value ? newOrderData.fields[item.id] = toNumber(item.field_value.value) : '' "
                                                        ng-model="newOrderData.order_fields[item.id]" 
                                                        class="form-control" 
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'date'">
                                                    <input type="date"
                                                        ng-init="item.field_value ? newOrderData.fields[item.id] = getDate(item.field_value.value) : newOrderData.customer.fields[item.id] = getDate(newOrderData.customer.fields[item.id]) "
                                                        ng-model="newOrderData.order_fields[item.id]" 
                                                        class="form-control" 
                                                        format-date
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'select'">
                                                    <select 
                                                        ng-init="item.field_value ? newOrderData.fields[item.id] = item.field_value.value : '' "
                                                        ng-model="newOrderData.order_fields[item.id]"
                                                        class="form-control">
                                                        <option value="">Seçim Yapınız</option>
                                                        <option value="{{ field }}" ng-repeat="field in stringToArray(item.value)">{{ field }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <a href="#" class="list-group-item" data-toggle="collapse" data-target="#special" ng-if="orderData.customerFields.length > 0">
                                        <strong> <i class="fa fa-info-circle"></i> Müşteri Özel Alanları </strong>
                                    </a>
        
                                    <div class="collapse" id="special">
                                        <div class="form-group mt10">
                                            <div class="form-group" ng-repeat="item in orderData.customerFields">
                                                <label for="">{{ item.name }}</label>
                                                <div ng-if="item.type == 'text'">
                                                    <input type="text"
                                                        ng-init="item.field_value ? newOrderData.customer.fields[item.id] = item.field_value.value : '' "
                                                        ng-model="newOrderData.address.fields[item.id]" 
                                                        class="form-control" 
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'number'">
                                                    <input type="text"
                                                        ng-init="item.field_value ? newOrderData.customer.fields[item.id] = toNumber(item.field_value.value) : '' "
                                                        ng-model="newOrderData.address.fields[item.id]" 
                                                        class="form-control" 
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'date'">
                                                    <input type="date"
                                                        ng-init="item.field_value ? newOrderData.customer.fields[item.id] = getDate(item.field_value.value) : newOrderData.customer.fields[item.id] = getDate(newOrderData.customer.fields[item.id]) "
                                                        ng-model="newOrderData.address.fields[item.id]" 
                                                        class="form-control" 
                                                        format-date
                                                        placeholder="{{ item.name }}">
                                                </div>
            
                                                <div ng-if="item.type == 'select'">
                                                    <select 
                                                        ng-init="item.field_value ? newOrderData.customer.fields[item.id] = item.field_value.value : '' "
                                                        ng-model="newOrderData.address.fields[item.id]"
                                                        class="form-control">
                                                        <option value="">Seçim Yapınız</option>
                                                        <option value="{{ field }}" ng-repeat="field in stringToArray(item.value)">{{ field }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-md-6 pn mn pl15">
                                    <div class="two-address" ng-if="newOrderData.location">
                                        <h4>Teslimat Müşteri Detayları</h4>
                                        <div class="form-group" ng-class="{ 'has-error': newWork.customer_name.$invalid && newWork.customer_name.$touched }">
                                                <div angucomplete-alt
                                                    name="location_name"
                                                    ng-model="newOrderData.location.name"
                                                    placeholder="Teslimat Müşteri Adı"
                                                    pause="100"
                                                    selected-object="locationSelected"
                                                    remote-url="api/find-location?s="
                                                    remote-url-data-field="locations"
                                                    search-fields="name,phone_number,address"
                                                    title-field="name"
                                                    description-field="address"
                                                    minlength="1"
                                                    input-class="form-control input-md"
                                                    match-class="highlight"
                                                    >
                                            </div>
                                        </div>
                                        <div class="form-group" 
                                            ng-class="{ 'has-error': newWork.address.$invalid }">
                                            <div class="input-group">
                                                <input 
                                                google-place ng-model="newOrderData.location.address" 
                                                ng-change="locationSelected(newOrderData.location.address,'search')" 
                                                id="googlePlaceInput" 
                                                class="form-control input-md" 
                                                placeholder="Adres" 
                                                name="address"
                                                required/>
                                                <span class="input-group-addon danger">
                                                    <a href="#" class="hint--medium hint--top-left " aria-label="Adresin caddesini yazarak çıkan önermelerden size uygun olanı seçiniz. İsterseniz map üzerindeki ikonu sürükleyerekte gideceğiniz adresi seçebilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                                </span>
                                            </div>
                                        </div>
        
                                        <div class="col-md-4 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.location.city" placeholder="İl" class="form-control input-md br0">
                                            </div>
                                        </div>
        
                                        <div class="col-md-4 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.location.district" placeholder="İlçe" class="form-control input-md br0">
                                            </div>
                                        </div>
        
                                        <div class="col-md-2 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.location.building_number" placeholder="Bina No" class="form-control input-md br0">
                                            </div>
                                        </div>
        
                                        <div class="col-md-2 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.location.apartment_number" placeholder="Daire No" class="form-control input-md br0">
                                            </div>
                                        </div>
    
                                        <div class="col-md-6 pln prn">
                                            <div class="form-group">
                                                <input type="text" ng-model="newOrderData.location.directions" placeholder="Adres Tarifi" class="form-control input-md">
                                            </div>
                                        </div>
        
                                        <div class="col-md-6 pln prn">
                                            <div class="form-group">
                                                <input 
                                                    type="text" 
                                                    class="form-control md" 
                                                    ui-mask="(999) 999-9999"  
                                                    ui-mask-placeholder ui-mask-placeholder-char=" " 
                                                    ng-model="newOrderData.location.phone_number"
                                                    ng-required="newOrderData.tracking_sms">
                                            </div>
    
                                            <div class="checkbox-custom fill checkbox-success mt10">
                                                <input 
                                                    type="checkbox" 
                                                    id="sms" 
                                                    ng-model="newOrderData.tracking_sms" 
                                                    ng-true-value="1" 
                                                    ng-false-value="0" 
                                                    name="tracking_sms">
                                                <label for="sms" class="fs11">
                                                    <a href="#" class="hint--medium hint--top pull-left" aria-label="Müşteri Telefonu. Çalışan işe başladığı zaman müşterinizin telefon numarasına takip linki gider!">
                                                        <i class="fa fa-question-circle"></i> 
                                                        Takip mesajı gönderilsin
                                                    </a>
                                                </label>
                                            </div>
                                        </div>
        
                                    </div>
    
                                    <div class="cargo-details">
                                        <h4>Kargo Detayları</h4>
                                        <div class="form-group mt10">
                                            <div class="form-group p5 mt10">
                                                <div class="radio-custom radio-primary pln radio-inline mb5 mln" ng-repeat="item in orderData.workTypes">
                                                    <input type="radio" id="{{ item.id }}" value="{{ item.id }}" name="type" ng-model="newOrderData.work_type">
                                                    <label for="{{ item.id }}">{{ item.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group mt10">
                                            <div class="radio-custom radio-inline pln radio-inline mb5 mln">
                                                <input type="radio" id="online_pay" name="radioExample" ng-value="'online'" ng-model="newOrderData.order_payment">
                                                <label for="online_pay">Kapıda Ödeme</label>
                                            </div>
                
                                            <div class="radio-custom radio-inline pln radio-inline mb5 mln">
                                                <input type="radio" id="offline_pay" name="radioExample" ng-value="'offline'" ng-model="newOrderData.order_payment">
                                                <label for="offline_pay">Ödendi</label>
                                            </div>
                                        </div>
                    
                                        <div class="row" ng-if="newOrderData.order_payment == 'online'">
                                            <div class="col-md-6 prn">
                                                <div class="form-group">
                                                    <label class="control-label mb10">Ödeme Tutarı</label>
                                                    <input type="number" ng-model="newOrderData.location.price" placeholder="Alınacak Ödeme Tutarı" class="form-control input-md br0">
                                                </div>
                                            </div>
                                            <div class="col-md-6 pln">
                                                <div class="form-group">
                                                    <label class="control-label mb10">Desi/Kg</label>
                                                    <input type="number" ng-model="newOrderData.weight" placeholder="Desi/Kg" class="form-control input-md br0">
                                                </div>
                                            </div>
                                        </div>
                
                                        <div class="form-group mt10">
                                            <label class="control-label mb10">Kargo İçeriği</label>
                                            <input type="text" ng-model="newOrderData.special_value" placeholder="Kargo İçeriği" class="form-control input-md">
                                        </div>

                                        <div class="form-group">
                                            <div class="input-group">
                                                <textarea rows="" cols="" ng-model="newOrderData.name" placeholder="Kargo Detayları" class="form-control input-md"></textarea>
                                                <span class="input-group-addon danger">
                                                    <a href="#" class="hint--medium hint--top-left" aria-label="Kargo hakkında detaylar girebilir veya not tutabilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
                    </div>
    
                    <div class="modal-footer bg-light modal-footer-fixed">
                        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
                        <button type="submit" class="btn btn-system">
                            <span ng-if="newOrderData.id">Güncelle</span>
                            <span ng-if="!newOrderData.id">Oluştur</span>
                        </button>
                    </div>
                </form>
    
            </div>
        </div>
    </div>
    